module.exports = __webpack_public_path__ + "static/media/explora-logos_transparent.27531504.png";